import { FC, Fragment, useCallback, useState } from 'react';
import { Flex, Grid, Link, Text } from '@servicetitan/anvil2';

import { MessageCard } from '../../message-card/message-card';
import { JobItemModel } from '../../../models/job.model';
import { MultilineText } from '../../multiline-text/multiline-text';
import { formatDateTime } from '../../../utils/format-date';

interface JobDetailProps {
    data: JobItemModel;
}

export const JobDetail: FC<JobDetailProps> = ({ data }) => {
    const [showMore, setShowMore] = useState<boolean | undefined>(undefined);

    const handleLineCalculated = useCallback((isTruncated: boolean) => {
        if (isTruncated) {
            setShowMore(false);
        } else {
            setShowMore(undefined);
        }
    }, []);

    const toggleShowAll = () => {
        setShowMore(!showMore);
    };

    return (
        <Fragment>
            <MessageCard className="m-b-2" flexDirection="column">
                <Text variant="headline" el="h3" size="small">
                    Job ID #{data.job_id}
                </Text>

                <div className="m-b-1">
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Job Type
                    </Text>
                    <Text size="small">{data.job_type}</Text>
                </div>

                <div className="m-b-1">
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Start Time
                    </Text>
                    <Text size="small">{formatDateTime(new Date(data.job_start_date))}</Text>
                </div>

                <Grid
                    templateColumns="1fr 1fr"
                    gap="2"
                    justifyContent="space-between"
                    alignItems="stretch"
                    className="m-b-1"
                >
                    <Flex direction="column">
                        <Text variant="eyebrow" className="m-b-half" size="small">
                            Technician
                        </Text>
                        <Text size="small">{data.technician}</Text>
                    </Flex>
                    <Flex direction="column">
                        <Text variant="eyebrow" className="m-b-half" size="small">
                            Duration
                        </Text>
                        <Text size="small">{data.job_duration}</Text>
                    </Flex>
                </Grid>

                <div>
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Job Summary
                    </Text>
                    <MultilineText
                        onLinesCalculated={handleLineCalculated}
                        maxLines={showMore ? undefined : 3}
                    >
                        {data.job_summary}
                    </MultilineText>
                </div>

                {showMore !== undefined && (
                    <Flex className="m-t-1">
                        <Link appearance="primary" quiet onClick={toggleShowAll}>
                            {showMore ? 'Show Less' : 'Show More'}
                        </Link>
                    </Flex>
                )}
            </MessageCard>

            {/* <JobTask data={data} />*/}
        </Fragment>
    );
};
